import React from "react";

export const Cause01: React.FC = () => {
  return (
    <div id="cause" className="cause01-section">
      <div className="cause01-container">
        <div className="cause01-content">
          <div className="cause01-left">
            <h2 className="cause01-title">¿Cuál es su causa?</h2>
            
            <p className="cause01-text">
              De momento no se sabe el origen real de la enfermedad pero se cree que nacemos
              con ella y que es resultado de varios factores como genéticos y ambientales.
            </p>
            <p className="cause01-text">
              Gracias al trabajo del <span className="cause01-highlight-blue">Dr. David Redwine</span> hay evidencia científica
              de que las células mesodermo esplácnico son las que crean las vísceras pélvicas. Así que
              cuando somos embriones las células se dividen, se dirigen y reparten por el cuerpo de
              acuerdo a su función. Por ejemplo, las del corazón y pulmón, van hacia el tórax y las
              que crean las vísceras pélvicas tendrían que ir juntas hacia la pelvis, pero esto a veces
              no sucede y estas células en lugar de migrar hacia la cavidad uterina, quedan por fuera
              de ella y es la respuesta inmune a estas células lo que genera la inflamación. Por eso la
              endometriosis se puede encontrar en cualquier parte u órgano del cuerpo.
            </p>
            <p className="cause01-summary">
              En resumen: cuando nos estamos formando, antes de nacer, algunas células distraídas toman
              el camino errado y... ¡tarán! se desarrolla la endometriosis.
            </p>
          </div>
          
          <div className="cause01-right">
            <h2 className="cause01-title cause01-title-hidden" aria-hidden="true">¿Cuál es su causa?</h2>
            
            <p className="cause01-text">
              La teoría de la menstruación retrógrada que se produce por menstruación que "vuelve
              por las trompas y se disemina en la pelvis y el abdomen" no es adecuada para explicar el
              origen de la enfermedad. Como ya señalamos, la enfermedad se ha encontrado en personas y
              animales que no menstrúan. Sí, lo repetiremos todas las veces que sea necesario.
            </p>
            <p className="cause01-text">
              Por otra parte, como bien dice la cita del Dr. Sinervo, es esencial quitar el foco de que la
              endometriosis es una enfermedad "asociada al período" o uterina. Esto retrasa los diagnósticos
              cuando la persona no presenta dolores menstruales muy severos y lleva a la{" "}
              <span className="cause01-highlight-blue">incorrecta idea de que quitar el útero podría resolver el problema.</span> De hecho,
              muchísimas veces pasa que se somete a pacientes a una histerectomía radical (quitan útero y
              ovarios) y después los médicos no se explican cómo la persona vuelve a tener lesiones de
              endometriosis en otros órganos. Así de pobre es el conocimiento sobre la enfermedad que hay hoy
              por hoy en la mayor parte del mundo.
            </p>
          </div>
        </div>
        
        <p className="moreinfo-footer">
          <strong>Fuentes:</strong> <a href="https://www.instagram.com/endolatam/" target="_blank" rel="noopener noreferrer">"La génesis de la endometriosis." Endolatam</a>
          <br /> <a href="https://www.centerforendo.com/" target="_blank" rel="noopener noreferrer">Center for Endometriosis Care</a>
        </p>
      </div>
    </div>
  );
};